import {REGION} from '../../constant';
import Anchor from '../Anchor';
import EllipsisText from '../EllipsisText';
import PageImage from '../PageImage';

interface IProps {
  thumbImg: string;
  landingUri: string;
  bgColor: string;
  textColor: string;
  title: string;
  subTitle?: string;
}

export default function NormalBanner({
  thumbImg,
  landingUri,
  bgColor,
  textColor,
  title,
  subTitle = '',
}: IProps) {
  const isKorea = REGION === 'kor';
  return (
    <Anchor
      display="flex"
      pageInfo={landingUri}
      className="items-center justify-between px-18 rounded-12 h-[154px] sm:h-[176px]"
      style={{backgroundColor: bgColor}}
    >
      <div className="flex flex-col justify-center flex-auto">
        <EllipsisText
          line={3}
          className={cn('w-full tracking-[-0.4px]', {
            's20-bold-white leading-25': isKorea,
            's16-bold-white leading-24': !isKorea,
          })}
          style={{color: textColor}}
        >
          {title}
        </EllipsisText>
        <EllipsisText
          line={2}
          className="mt-10 opacity-80 s12-regular-white leading-14"
          style={{color: textColor}}
        >
          {subTitle}
        </EllipsisText>
      </div>
      <div
        className={cn(
          'overflow-hidden h-full w-[131px] sm:w-[150px]',
          'flex flex-none items-center'
        )}
      >
        <PageImage
          src={thumbImg}
          alt=""
          className="w-full h-full"
          pictureClassName="h-full"
        />
      </div>
    </Anchor>
  );
}
